import { Injectable } from "@angular/core";
import { BaseEntityService } from "./rest-common.service";
import { HttpClient } from "@angular/common/http";
import { UserService } from "./user.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class SiteService extends BaseEntityService {
  public resource_url = `${this.BASE_CDP_URL}/site-tag/`;
  constructor(
    public http: HttpClient,
    public toastr: NotificationService,
    public userService: UserService
  ) {
    super();
  }

  getWebData(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/`, '', params)
    return this.get(url);
  }

  generateURL(id, params={}){
    let url = this.buildUrl(`${this.resource_url}${id}/tag-url/`, '', params)
    return this.get(url);
  }

}
